const BookingCategory = {
  Block: 'Block',
  Standard: 'Standard'
};

export default BookingCategory;
